import { Link } from "react-router-dom";

// Modern dark-mode client folder card matching exact reference:
// - Outer rounded container (#222222, rounded-[32px])
// - Thick dark frame framing the top orange window (#EA6D11, rounded-t-[20px])
// - Photos float on top of orange canvas with controlled, elegant hover fan lift
// - Dark flap with smooth curved scoop tab and rounded top-right corner (Images 1 & 2), "Portfólio", client name, 3 dots, white logo and tags
export const ClientFolder = ({ folder }) => {
    const slots = [0, 1, 2].map((i) => folder.photos?.[i] ?? null);

    return (
        <Link
            to={folder.href}
            aria-label={`${folder.client} — ver o case`}
            className="folder group relative block w-full select-none"
        >
            <div className="relative w-full aspect-[340/365] sm:aspect-[350/380] rounded-[32px] sm:rounded-[36px] bg-[#222222] overflow-hidden shadow-2xl border border-white/5 transition-all duration-300 group-hover:-translate-y-2 group-hover:shadow-[0_24px_48px_rgba(0,0,0,0.5)] flex flex-col pt-3 px-3 sm:pt-3.5 sm:px-3.5">
                {/* Top Orange Header Window */}
                <div className="relative w-full h-[52%] bg-[#EA6D11] rounded-t-[20px] sm:rounded-t-[24px]">
                    <div className="absolute inset-x-[-12px] sm:inset-x-[-14px] bottom-0 h-full flex items-end justify-center pointer-events-none pb-1">
                        {/* Photo 1 (Left - in front of Photo 2, contained inside orange in rest, reaches black border on hover) */}
                        <div className="absolute bottom-0 left-1/2 -translate-x-[76%] sm:-translate-x-[78%] translate-y-[28%] -rotate-[11deg] z-30 transition-all duration-400 ease-out group-hover:-translate-x-[102%] sm:group-hover:-translate-x-[108%] group-hover:translate-y-[8%] group-hover:-rotate-[15deg]">
                            <div className="aspect-[4/5] w-[120px] sm:w-[138px] md:w-[150px] rounded-[14px] sm:rounded-[16px] overflow-hidden shadow-[0_12px_28px_rgba(0,0,0,0.5)]">
                                {slots[0] ? (
                                    <img
                                        src={slots[0].src}
                                        alt=""
                                        loading="lazy"
                                        className="h-full w-full object-cover"
                                    />
                                ) : (
                                    <div className="h-full w-full bg-[#D9D9D9]" />
                                )}
                            </div>
                        </div>

                        {/* Photo 2 (Center - behind Photo 1, in front of Photo 3, exact center) */}
                        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-[22%] rotate-0 z-20 transition-all duration-400 ease-out group-hover:-translate-x-1/2 group-hover:translate-y-[2%] group-hover:rotate-0">
                            <div className="aspect-[4/5] w-[124px] sm:w-[142px] md:w-[154px] rounded-[14px] sm:rounded-[16px] overflow-hidden shadow-[0_10px_24px_rgba(0,0,0,0.45)]">
                                {slots[1] ? (
                                    <img
                                        src={slots[1].src}
                                        alt=""
                                        loading="lazy"
                                        className="h-full w-full object-cover"
                                    />
                                ) : (
                                    <div className="h-full w-full bg-[#D9D9D9]" />
                                )}
                            </div>
                        </div>

                        {/* Photo 3 (Right - behind Photo 2, contained inside orange in rest, reaches black border on hover) */}
                        <div className="absolute bottom-0 left-1/2 -translate-x-[24%] sm:-translate-x-[22%] translate-y-[28%] rotate-[11deg] z-10 transition-all duration-400 ease-out group-hover:translate-x-[2%] sm:group-hover:translate-x-[8%] group-hover:translate-y-[8%] group-hover:rotate-[15deg]">
                            <div className="aspect-[4/5] w-[120px] sm:w-[138px] md:w-[150px] rounded-[14px] sm:rounded-[16px] overflow-hidden shadow-[0_8px_20px_rgba(0,0,0,0.4)]">
                                {slots[2] ? (
                                    <img
                                        src={slots[2].src}
                                        alt=""
                                        loading="lazy"
                                        className="h-full w-full object-cover"
                                    />
                                ) : (
                                    <div className="h-full w-full bg-[#D9D9D9]" />
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bottom Folder Flap with Custom SVG Shape (Negative margin over the dark frame) */}
                <div className="relative -mx-3 sm:-mx-3.5 w-[calc(100%+24px)] sm:w-[calc(100%+28px)] flex-1 -mt-9 sm:-mt-11 z-40 flex flex-col justify-between">
                    {/* Flap SVG Silhouette with Smooth Curved Scoop and Rounded Top-Right Corner */}
                    <svg
                        viewBox="0 0 360 220"
                        className="absolute inset-0 h-full w-full pointer-events-none text-[#222222]"
                        preserveAspectRatio="none"
                    >
                        <path
                            d="M 0 20
                               Q 0 0 20 0
                               L 115 0
                               C 142 0, 155 36, 185 36
                               L 332 36
                               Q 360 36 360 64
                               L 360 188
                               Q 360 220 328 220
                               L 32 220
                               Q 0 220 0 188
                               Z"
                            fill="currentColor"
                        />
                    </svg>

                    {/* Top Flap Section: "Portfólio" in tab, and lowered row with Client Title + 3 Dots */}
                    <div className="relative z-10 px-5 pt-3 sm:px-6 sm:pt-3.5 flex flex-col">
                        <div>
                            <span className="text-[12px] sm:text-[13px] text-white/50 font-normal block leading-none">
                                Portfólio
                            </span>
                        </div>

                        {/* Lowered Row: Client Name + 3 Dots safely below the scoop curve and margin */}
                        <div className="flex items-center justify-between gap-3 mt-3.5 sm:mt-4">
                            <h3 className="text-[16px] sm:text-[17.5px] text-white font-bold block leading-tight truncate">
                                {folder.client}
                            </h3>

                            {/* Three Dots Icon lowered comfortably inside the dark flap */}
                            <div className="flex items-center gap-1 text-white/40 shrink-0">
                                <span className="w-1.5 h-1.5 rounded-full bg-current"></span>
                                <span className="w-1.5 h-1.5 rounded-full bg-current"></span>
                                <span className="w-1.5 h-1.5 rounded-full bg-current"></span>
                            </div>
                        </div>
                    </div>

                    {/* Middle Row: Client Logo */}
                    <div className="relative z-10 px-5 sm:px-6 my-auto pt-2 pb-1 flex items-center h-[52px]">
                        <img
                            src={folder.logo}
                            alt=""
                            loading="lazy"
                            className={`w-auto object-contain ${
                                folder.noInvert ? "" : "brightness-0 invert"
                            } opacity-95 transition-transform duration-300 group-hover:scale-105 ${
                                folder.logoClassName || "max-h-[40px] sm:max-h-[44px] max-w-[160px]"
                            }`}
                        />
                    </div>

                    {/* Bottom Row: Document Icon and Tags */}
                    <div className="relative z-10 px-5 pb-5 sm:px-6 sm:pb-6 flex items-center gap-2 text-[12.5px] sm:text-[13.5px] text-white/60 font-normal">
                        <svg
                            className="w-3.5 h-3.5 text-white/50 shrink-0"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                            <polyline points="14 2 14 8 20 8" />
                        </svg>
                        <span className="truncate">{folder.tags}</span>
                    </div>
                </div>
            </div>
        </Link>
    );
};
